module.exports = __webpack_public_path__ + "img/login-log.d8b5b664.png";